import React from 'react';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';

const OrderLinesExpandListTemplate = ({
	viewStore,
	viewStore: { data, listStore, tableData, queryUtility, noDataItem, change, loading, showActions },
	actions,
}) => {
	if (loading) return null;
	return (
		<section>
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					viewStore,
					actions,
					showActions,
					noDataItem,
					showImage: false,
					change,
				}}
				actions={viewStore}
			/>
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(OrderLinesExpandListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderLinesExpandListTemplate.jsx